/** Dashboard session limits (security). */
export const IDLE_LIMIT_MS = 30 * 60 * 1000;
export const WARNING_BEFORE_MS = 2 * 60 * 1000;
export const MAX_SESSION_MS = 12 * 60 * 60 * 1000;

export const LAST_ACTIVITY_KEY = "aci_last_activity";
export const LOGIN_AT_KEY = "aci_login_at";

export type SessionState = "active" | "warning" | "expired";

export function sessionState(now: number, lastActivity: number, loginAt: number): SessionState {
  if (now - loginAt >= MAX_SESSION_MS) return "expired";
  const idle = now - lastActivity;
  if (idle >= IDLE_LIMIT_MS) return "expired";
  if (idle >= IDLE_LIMIT_MS - WARNING_BEFORE_MS) return "warning";
  return "active";
}
